import api from './api';

// Channels — omnichannel edge config. Maps a receiving address (WhatsApp
// number / mailbox) to a workflow for two-way conversation. App-scoped; the
// backend isolates rows by the app's org and settings.routing.app_id.

export const fetchChannels = async (appId) => {
    const response = await api.get(`/apps/${appId}/channels`);
    return response.data;
};

export const createChannel = async (appId, data) => {
    const response = await api.post(`/apps/${appId}/channels`, data);
    return response.data;
};

export const updateChannel = async (appId, channelUuid, data) => {
    const response = await api.put(`/apps/${appId}/channels/${channelUuid}`, data);
    return response.data;
};

export const deleteChannel = async (appId, channelUuid) => {
    const response = await api.delete(`/apps/${appId}/channels/${channelUuid}`);
    return response.data;
};

// Activities of a workflow's published (or latest) version — for the routing
// config's handler-activity picker.
export const fetchChannelHandlerActivities = async (appId, workflowUuid) => {
    const response = await api.get(`/apps/${appId}/channel-handler-activities`, {
        params: { workflow_uuid: workflowUuid },
    });
    return response.data;
};
